import { Component, ChangeDetectionStrategy } from "@angular/core";
import { GridBaseComponent } from "../grid-base/grid-base.component";
import { RouterLink } from "@angular/router";

@Component({
    selector: "rask-grid-sref",
    templateUrl: "./grid-sref.component.html",
    styleUrls: ["./grid-sref.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink]
})

export class GridSrefComponent extends GridBaseComponent {
}
